import React, { useEffect, useState } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import { FaUpload } from "react-icons/fa";
import { useMutation, useQuery } from "react-query";
import {
  getCountries,
  postCountry,
  showCountry,
  UpdateCountry,
} from "../../../../MyApi/admin/countries/countries";
import { toast } from "react-toastify";
import SkeletonWrapper from "../../../UI/skeletonWrapper";
import i18next from "i18next";
import { timeZones } from "./timezone";

const AddCountryModal = ({ show, onClose, refetch, modalMode, modalId }) => {
  const [formData, setFormData] = useState({
    name: "",
    code: "",
    currency_name: "",
    timezone: "",
    currency_symbol: "",
    currency_unit: "",
    flag: null,
    is_active: 1,
    service_fee: "",
    tax: "",
  });
  const [selectedLangCode, setSelectedLangCode] = useState("");

  const { data, isLoading } = useQuery(
    ["showCountries", modalId, selectedLangCode],
    () => showCountry(modalId, selectedLangCode),
    {
      enabled: modalMode === "edit" && !!modalId,
    },
  );
  const country = data?.data?.country || {};
  useEffect(() => {
    if (modalMode === "edit" && country) {
      setFormData((prev) => ({
        ...prev,
        name: country.name,
        code: country.code,
        currency_name: country.currency_name,
        currency_symbol: country.currency_symbol || "",
        flag: country.flag, 
        is_active: country.is_active ? 1 : 0,
        currency_factor: country.currency_factor,
        currency_unit: country.currency_unit,
        service_fee: country.service_fee,
        tax: country.tax,
        timezone: country.timezone,
      }));
    }
  }, [data]);
  useEffect(() => {
    if (modalMode === "edit") {
      const currentLang = i18next.language;
      console.log("currentLang", currentLang);
      setSelectedLangCode(currentLang);
    }
  }, [modalMode]);
  console.log("modalMode", modalMode);
  const handleChangeLang = (e) => {
    setSelectedLangCode(e.target.value);
  };
  const [validated, setValidated] = useState(false);

  const mutation = useMutation({
    mutationKey: ["postcountry"],
    mutationFn: (postData) => postCountry(postData),
    onSuccess: (data) => {
      toast.success(`${data.message}`);
      onClose("country", "add");
      refetch();
    },
    onError: (error) => {
      const message = error?.response?.data?.message || "حدث خطأ ما";
      toast.error(message);
    },
  });
  const mutationUpdate = useMutation({
    mutationKey: ["updatecountry", modalId],
    mutationFn: (postData) => UpdateCountry(postData, "", modalId),
    onSuccess: (data) => {
      toast.success(`${data.message}`);
      onClose("country", "edit");
      refetch();
    },
    onError: (error) => {
      const message = error?.response?.data?.message || "حدث خطأ ما";
      toast.error(message);
    },
  });

  const handleChange = (e) => {
    const { name, value, type, files } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "file" ? files[0] : value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const form = e.currentTarget;
    const isOldImage =
      typeof formData.flag === "string" && formData.flag.startsWith("http");
    // If form is invalid -> stop submission
    if (!form.checkValidity()) {
      e.stopPropagation();
      setValidated(true);
      return;
    }

    const sendFormData = new FormData();
    sendFormData.append("name", formData.name);
    sendFormData.append("code", formData.code);
    sendFormData.append("currency_symbol", formData.currency_symbol);
    sendFormData.append("currency_name", formData.currency_name);
    sendFormData.append("currency_unit", formData.currency_unit);
    sendFormData.append("currency_factor", formData.currency_factor);
    sendFormData.append("service_fee_percentage", formData.service_fee);
    sendFormData.append("tax_rate", formData.tax);
    sendFormData.append("is_active", formData.is_active);
    sendFormData.append("timezone",formData.timezone)
    if (!isOldImage) {
      sendFormData.append("flag", formData.flag);
    }

    if (modalMode === "edit") {
      sendFormData.append("_method", "PUT");
      sendFormData.append("lang", selectedLangCode);
    }

    if (modalMode === "edit") {
      mutationUpdate.mutate(sendFormData);
    } else {
      mutation.mutate(sendFormData);
    }
  };

  return (
    <Modal show={show} onHide={() => onClose("country")} centered>
      <Form
        noValidate
        validated={validated}
        onSubmit={handleSubmit}
        className="add"
      >
        <Modal.Header closeButton>
          <Modal.Title>
            {modalMode === "edit" ? "تعديل" : "إضافة"} دولة جديدة
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          {modalMode === "edit" ? (
            <div>
              <label htmlFor="" className="form-label ">
                اللغة
              </label>
              <select
                className="form-control w-50"
                onChange={handleChangeLang}
                value={selectedLangCode}
              >
                <option value="ar">العربية</option>
                <option value="en">English</option>
              </select>
            </div>
          ) : (
            <p className="text-muted small mb-3">أضف دولة جديدة للنظام</p>
          )}
          <label htmlFor="time-zone" className="form-label">منطقة زمنية</label>
          <select name="timezone" id="time-zone" className="form-select" onChange={handleChange} value={formData.timezone}>
            <option value="">اختر المنطقة الزمنية للتوقيت</option>
            {timeZones.map((time, i) => (
              <option key={i} value={time.value}>
                {time.label}
              </option>
            ))}
          </select>

          <Form.Group className="mb-3">
            <Form.Label>اسم الدولة</Form.Label>
            <SkeletonWrapper isLoading={isLoading}>
              {" "}
              <Form.Control
                type="text"
                name="name"
                placeholder="ادخل اسم الدولة"
                value={formData.name}
                onChange={handleChange}
                required
              />{" "}
            </SkeletonWrapper>
            <Form.Control.Feedback type="invalid">
              اسم الدولة مطلوب
            </Form.Control.Feedback>
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>كود الدولة</Form.Label>
            <SkeletonWrapper isLoading={isLoading}>
              {" "}
              <Form.Control
                type="text"
                name="code"
                placeholder="ادخل كود الدولة"
                value={formData.code}
                onChange={handleChange}
                required
              />{" "}
            </SkeletonWrapper>
            <Form.Control.Feedback type="invalid">
              كود الدولة مطلوب
            </Form.Control.Feedback>
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>اسم العملة</Form.Label>{" "}
            <SkeletonWrapper isLoading={isLoading}>
              <Form.Control
                type="text"
                name="currency_name"
                placeholder="ادخل اسم العملة"
                value={formData.currency_name}
                onChange={handleChange}
                required
              />{" "}
            </SkeletonWrapper>
            <Form.Control.Feedback type="invalid">
              اسم العملة مطلوب
            </Form.Control.Feedback>
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>رمز العملة</Form.Label>
            <SkeletonWrapper isLoading={isLoading}>
              <Form.Control
                type="text"
                name="currency_symbol"
                placeholder="ادخل رمز العملة"
                value={formData.currency_symbol}
                onChange={handleChange}
                required
              />{" "}
            </SkeletonWrapper>
            <Form.Control.Feedback type="invalid">
              رمز العملة مطلوب
            </Form.Control.Feedback>
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>وحدة العملة </Form.Label>
            <SkeletonWrapper isLoading={isLoading}>
              {" "}
              <Form.Control
                type="text"
                name="currency_unit"
                placeholder=" وحدة العملة"
                value={formData.currency_unit}
                onChange={handleChange}
                required
              />{" "}
            </SkeletonWrapper>
            <Form.Control.Feedback type="invalid">
              وحدة العملة مطلوب
            </Form.Control.Feedback>
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label> الخدمة </Form.Label>
            <SkeletonWrapper isLoading={isLoading}>
              {" "}
              <Form.Control
                type="text"
                name="service_fee"
                placeholder="الخدمة"
                value={formData.service_fee}
                onChange={handleChange}
                required
              />{" "}
            </SkeletonWrapper>
            <Form.Control.Feedback type="invalid">
              الخدمة مطلوب
            </Form.Control.Feedback>
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label> الضريبة </Form.Label>
            <SkeletonWrapper isLoading={isLoading}>
              {" "}
              <Form.Control
                type="text"
                name="tax"
                placeholder="الضريبة"
                value={formData.tax}
                onChange={handleChange}
                required
              />{" "}
            </SkeletonWrapper>
            <Form.Control.Feedback type="invalid">
              الضريبة مطلوب
            </Form.Control.Feedback>
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>عامل العملة </Form.Label>
            <SkeletonWrapper isLoading={isLoading}>
              {" "}
              <Form.Control
                type="text"
                name="currency_factor"
                placeholder=" عامل العملة"
                value={formData.currency_factor}
                onChange={handleChange}
                required
              />{" "}
            </SkeletonWrapper>
            <Form.Control.Feedback type="invalid">
              عامل العملة مطلوب
            </Form.Control.Feedback>
          </Form.Group>

          <SkeletonWrapper isLoading={isLoading}>
            <Form.Group>
              <Form.Label>صورة العلم</Form.Label>
              <div
                className="border rounded-3 text-center py-4 position-relative"
                style={{
                  borderStyle: "dashed",
                  cursor: "pointer",
                  backgroundColor: "#f9f9f9",
                }}
                onClick={() => document.getElementById("flagInput").click()}
              >
                <FaUpload size={24} className="text-muted mb-2" />
                <p className="mb-0 text-muted">
                  تحميل صورة العلم
                  <br />
                  <small>(JPG / PNG) بدقة 16:9</small>
                </p>
                {formData.flag &&  (  
                  <img src={formData.flag instanceof File ? URL.createObjectURL(formData.flag):formData.flag} alt="" width={50} height={50} />
                )}   
              </div>  

              <Form.Control
                id="flagInput"
                type="file"
                name="flag"
                accept="image/png, image/jpeg"
                onChange={handleChange}
                hidden
              />

              {formData.flag && (
                <p className="text-success mt-2">{formData.flag.name}</p>
              )}
              <div></div>

              <Form.Control.Feedback type="invalid">
                صورة العلم مطلوبة
              </Form.Control.Feedback>
            </Form.Group>
          </SkeletonWrapper>
        </Modal.Body>

        <Modal.Footer className="justify-content-start">
          <Button
            variant="primary"
            type="submit"
            disabled={mutation.isLoading || mutationUpdate.isLoading}
          >
            {mutation.isLoading || mutationUpdate.isLoading
              ? "جارٍ الإضافة..."
              : modalMode === "edit"
                ? "تعديل الدولة"
                : "إضافة دولة"}
          </Button>
          <button
            className="btn btn-white"
            type="button"
            onClick={() => onClose("country")}
          >
            إلغاء
          </button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};

export default AddCountryModal;
